import styled, { keyframes } from 'styled-components';

const scroll = keyframes`
  0% { transform: translateX(0); }
  100% { transform: translateX(-33.333%); }
`;

export const LogoSliderContainer = styled.div`
  background-color: #ffffff;
  overflow: hidden;
  padding: 16px 0;
  width: 100%;
`;

export const SliderTitle = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #000000;
  text-align: center;
  margin: 0 0 14px 0;

  @media (max-width: 768px) {
    font-size: 18px;
    margin-bottom: 10px;
  }
`;

export const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow: hidden;
`;

export const LogoBand = styled.div`
  display: flex;
  flex-wrap: nowrap;
  animation: ${scroll} 28s linear infinite;
  width: fit-content;
`;

export const LogoGroup = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const LogoItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 28px;

  @media (max-width: 768px) {
    padding: 0 18px;
  }
`;

export const LogoImage = styled.img`
  height: 50px;
  width: auto;
  object-fit: contain;
  opacity: 0.75;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 1;
  }

  @media (max-width: 768px) {
    height: 36px;
  }
`;
